import * as jsxRuntime from "/builds/it-engineering/it-ship-it/it-shipit-marketplace-ui/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment